export const GET_MANAGER_LEADS_LEAD_MANAGE = 'GET_MANAGER_LEADS_LEAD_MANAGE';
export const GET_MANAGER_LEADS_LEAD_MANAGE_SUCCESS = 'GET_MANAGER_LEADS_LEAD_MANAGE_SUCCESS';
export const GET_MANAGER_LEADS_LEAD_MANAGE_FAILURE = 'GET_MANAGER_LEADS_LEAD_MANAGE_FAILURE';

export const COUNT_MANAGER_LEADS_SUCCESS = 'COUNT_MANAGER_LEADS_SUCCESS';
export const COUNT_MANAGER_LEADS_FAILURE = 'COUNT_MANAGER_LEADS_FAILURE';

export const SET_MANAGER_LEAD_MANAGE_KEY = 'SET_MANAGER_LEAD_MANAGE_KEY';
export const SET_MANAGER_LEAD_MANAGE_NEW_KEY_VALUE = 'SET_MANAGER_LEAD_MANAGE_NEW_KEY_VALUE';
export const UPDATE_MANAGER_LEAD_MANAGE_KEY = 'UPDATE_MANAGER_LEAD_MANAGE_KEY';

export const SET_MANAGER_LEAD_MANAGE_LOADING = 'SET_MANAGER_LEAD_MANAGE_LOADING';

export const SET_MANAGER_LEAD_MANAGE_PAGINATION = 'SET_MANAGER_LEAD_MANAGE_PAGINATION';



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/redux/constants/get_manager_leads.constants.js